import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    mode: 'hash',
    // base: process.env.BASE_URL,
    base: '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home'),
            meta: {
                title: process.env.VUE_APP_HOME_TITLE + process.env.VUE_APP_HOME_TEST
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login'),
            meta: {
                title: process.env.VUE_APP_HOME_TITLE + process.env.VUE_APP_HOME_TEST + '-登录'
            }
        }, 
        {
            path: '/local',
            name: 'local',
            component: () => import('./views/Local'),
            meta: {
                title: process.env.VUE_APP_HOME_TITLE + process.env.VUE_APP_HOME_TEST
            }
        },
        {
            path: '/manual',
            name: 'manual',
            component: () => import('./views/Manual'),
            meta: {
                title: '百家号发布' + process.env.VUE_APP_HOME_TEST
            }
        }, {
            path: '/ystlogin',
            name: 'ystlogin',
            component: () => import('./views/YstLogin'),
            meta: {
                title: '亿视推授权' + process.env.VUE_APP_HOME_TEST + '-登录'
            }
        }, {
            path: '/ysthome',
            name: 'ysthome',
            component: () => import('./views/YstHome'),
            meta: {
                title: '亿视推授权' + process.env.VUE_APP_HOME_TEST
            }
        }
        , {
            path: '/ystusers',
            name: 'ystusers',
            component: () => import('./views/YstHome'),
            meta: {
                title: '亿视推授权' + process.env.VUE_APP_HOME_TEST
            }
        },
           {
            path: '/ystlocal',
            name: 'ystlocal',
            component: () => import('./views/YstLocal'),
            meta: {
                title: process.env.VUE_APP_HOME_TITLE + process.env.VUE_APP_HOME_TEST
            }
        },
       {
            path: '/watch',
            name: 'watch',
            component: () => import('./views/watch/Menu'),
            children: [

                {
                    path: '/watch/hecheng',
                    name: 'watch-hecheng',
                    component: () => import('./views/watch/Hecheng'),
                    meta: {
                        title: '合成列表' + process.env.VUE_APP_HOME_TEST
                    },
                },
                {
                    path: '/watch/publish',
                    name: 'watch-publish',
                    component: () => import('./views/watch/Publish'),
                    meta: {
                        title: '合成列表' + process.env.VUE_APP_HOME_TEST
                    },
                },
                {
                    path: '/watch/jigouhao',
                    name: 'watch-jigouhao',
                    component: () => import('./views/watch/Jigouhao'),
                    meta: {
                        title: '机构号列表' + process.env.VUE_APP_HOME_TEST
                    },
                },
                {
                    path: '/watch/setting',
                    name: 'watch-setting',
                    component: () => import('./views/watch/Setting'),
                    meta: {
                        title: '营销监测' + process.env.VUE_APP_HOME_TEST
                    },
                }
            ]
        }]
})